import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./Lens_Details_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getAllAddOn, getAllLenseProduct } from "../../../../features/master/masterSlice";
import parse from "html-react-parser";
import Lense_prescription_modal from "../want-buy-modal/Lense_prescription_modal";
import AddOn_Details_Modal from "./Addon_Details_Modal";
import { Button } from "react-bootstrap";
const Lens_Details_Modal = ({
  lensTypeId,
  product,
  variant,
  product_id,
  ...props
}) => {
  const data = [
    {
      img: "/assets/images/popular-product/1.png",
      label: "With Power",
      descn: ["Double Side Anti-Glare Lens", "Scratch Resistant"],
      selling_price: 1400,
      mrp: 1900,
    },
    {
      img: "/assets/images/popular-product/2.png",
      label: "Zero Power",
      descn: ["Double Side Anti-Glare Lens", "Scratch Resistant"],
      selling_price: 1400,
      mrp: 1900,
    },
    {
      img: "/assets/images/popular-product/3.png",
      label: "Reading Power",
      descn: ["Double Side Anti-Glare Lens", "Scratch Resistant"],
      selling_price: 1400,
      mrp: 1900,
    },
    {
      img: "/assets/images/popular-product/2.png",
      label: "Frame Only",
      descn: ["Double Side Anti-Glare Lens", "Scratch Resistant"],
      selling_price: 1400,
      mrp: 1900,
    },
    {
      img: "/assets/images/popular-product/1.png",
      label: "With Power",
      descn: ["Double Side Anti-Glare Lens", "Scratch Resistant"],
      selling_price: 1400,
      mrp: 1900,
    },
  ];

  const [lenseId, setLenseId] = useState(null);
  const [lensemodal, setLensemodal] = useState(false);
  const dispatch = useDispatch();
  const add_on = useSelector((state) => state.master.lense_product);
  useEffect(() => {
    dispatch(getAllLenseProduct({id:lensTypeId}));
  }, [lensTypeId]);
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Lens_Details_Modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="modal_content_div">
            <p className="title_text">Choose Your Lens</p>

            <div className="all_cards_holder">
              {add_on?.map((item) => {
                return (
                  <div
                    className="row_holder"
                    onClick={() => {
                      props?.onHide();
                      setLensemodal(true);
                      setLenseId(item?.id);
                    }}
                  >
                    <div className="left_img_div">
                      <img
                        src={process.env.REACT_APP_IMAGE_URL + item?.image}
                        className="img_class"
                      />
                    </div>
                    <div className="text_holder">
                      <div className="first_div">
                        <div className="left_text_div">
                          <p className="label_text">{item?.name}</p>
                          <ul >
                            {parse(
                              typeof item?.description === "string"
                                ? item.description
                                : ""
                            )}
                            {/* {item?.descn?.map((it) => {
                              return <li className="inner_li">{it}</li>;
                            })} */}
                          </ul>
                        </div>

                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faAngleRight}
                            className="icon"
                          />
                        </div>
                      </div>

                      <div className="price_div">
                        <p className="rate_descn_text">Rate cut is now Live</p>
                        <p className="price_text">
                          ₹{item?.price}{" "}
                          <span className="mrp_text">₹{item?.mrp}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>




           

          </div>
        </Modal.Body>
      </Modal>
      <AddOn_Details_Modal
        product={product}
        variant={variant}
        product_id={product_id}
        lensTypeId={lensTypeId}
        lenseId={lenseId}
        // lensId={lensId}
        // lensOptionId={lensOptionId}
        show={lensemodal}
        onHide={() => setLensemodal(false)}
      />
    </>
  );
};

export default Lens_Details_Modal;
